/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/


import Vue from 'vue';
import App from './App.vue';
import * as Sentry from "@sentry/vue";

// Vuesax Component Framework
import Vuesax from 'vuesax';
import 'material-icons/iconfont/material-icons.css'; //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

import { Auth0Plugin } from "./auth";

/* import {
  domain,
  clientId,
  audience
} from "../auth_config.json"; */

var domain = process.env.VUE_APP_AUTH_DOMAIN;
var clientId = process.env.VUE_APP_AUTH_CLIENTID;
var audience = process.env.VUE_APP_AUTH_AUDIENCE;

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ?
      appState.targetUrl :
      window.location.pathname
    );
  }
});

Vue.use(Vuesax);

// Theme Configurations
import '../themeConfig.js';


// Globally Registered Components
import './globalComponents.js';


// Styles: SCSS
import './assets/scss/main.scss';


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router';


// Vuex Store
import store from './store/store';

// PrismJS
import 'prismjs';
import 'prismjs/themes/prism-tomorrow.css';

// Vuejs - Vue wrapper for hammerjs
import {
  VueHammer
} from 'vue2-hammer';
Vue.use(VueHammer);

//SweetAlert
import VueSwal from 'vue-swal';
Vue.use(VueSwal);

import * as VueGoogleMaps from 'vue2-google-maps'


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBrB5KCGBquAgaTWxp9b5TDGaO0-SR7pmo',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then set installComponents to 'false'.
  //// If you want to automatically install all the components this property must be set to 'true':
  installComponents: true
});
 
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';



 

// Feather font icon
require('./assets/css/iconfont.css');

/* Vue.use(require('vue-moment')); */

const moment = require('moment');
//require('moment/locale/fr');
 
Vue.use(require('vue-moment'), {
    moment
});
Vue.filter('moment', function (value, format) {
  if (value === null || value === undefined || format === undefined) {
    return ''
  }
  if (format === 'from') {
    return moment(value).fromNow()
  }
  return moment(value).format(format)
});

//import Axios from 'axios';

import fr from 'vee-validate/dist/locale/fr';
import VeeValidate, {
  Validator
} from 'vee-validate';
Vue.use(VeeValidate);
Validator.localize('fr', fr);

Vue.config.productionTip = false;

/* Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
} */

/* import Rollbar from 'rollbar';
Vue.prototype.$rollbar = new Rollbar({
  accessToken: 'c114340c6c0f4154bf805dfbdc1749ba',
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging',
  environment: process.env.VUE_APP_ENV
}); */

import VueCompositionApi from '@vue/composition-api'
Vue.use(VueCompositionApi)
 

/* Vue.config.errorHandler = (err, vm) => {
  vm.$rollbar.error(err);
  throw err; // rethrow
}; */

Sentry.init({
  Vue,
  dsn: "https://2ef60a7c8c5e9f200105eba00ae16a13@o4511210248077312.ingest.de.sentry.io/4511210257449040",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');